var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "about-outer-wrapper",
      class: {
        authenticated: _vm.isAuthenticated,
        mobile: _vm.isMobile(_vm.$mq)
      }
    },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "about container",
          attrs: { "data-testid": "about_classic" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass: "about-staff-members",
              attrs: { "data-testid": "about_staff_members" }
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "staff-members-grid",
                  attrs: { "data-testid": "about_staff_members_grid" }
                },
                [
                  _vm._l(_vm.staff_members, function(staff_member, index) {
                    return [
                      _vm.shouldPrintStaffMemberGridRuler(index)
                        ? _c("hr", {
                            staticClass: "staff-member-ruler",
                            class: {
                              "ruler-3": index % 3 === 0,
                              "ruler-5": index % 5 === 0
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("StaffMemberItem", {
                        key: staff_member.id,
                        attrs: { staffMember: staff_member }
                      })
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("hr")
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass: "about-careers",
              attrs: { "data-testid": "about_careers" }
            },
            [
              _vm._m(2),
              _vm._v(" "),
              _c("article", [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "section-description" }, [
                  _c("p", [
                    _vm._v(
                      "\n            We're proud of our mission and the business we've built around it. We work really\n            hard, and most days we love our jobs. Learn about working at Brilliant and our current\n            openings.\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "no-margin-bottom" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-accent",
                          attrs: {
                            to: { name: "careers_page" },
                            "data-testid": "about_link_to_careers_page"
                          }
                        },
                        [_vm._v("See Brilliant careers\n            ")]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("hr")
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass: "about-press",
              attrs: { id: "for-the-press", "data-testid": "about_press" }
            },
            [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "press-cards" },
                [
                  _c("Card", {
                    attrs: {
                      title: "Press Kit",
                      image: "brilliant-logo",
                      url:
                        "https://docs.google.com/document/d/16BXam0d38RGOqVweRRNm3dyJUs0j3Z0w7u0p41E9H5I/preview?usp=sharing"
                    }
                  }),
                  _vm._v(" "),
                  _c("Card", {
                    staticClass: "last",
                    attrs: {
                      title: "pr@brilliant.org",
                      image: "inbox",
                      url: "mailto:pr@brilliant.org"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("hr")
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass: "about-in-memoriam",
              attrs: { "data-testid": "about_in_memoriam" }
            },
            [
              _vm._m(5),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "remembered-grid",
                  attrs: { "data-testid": "about_in_memoriam_grid" }
                },
                _vm._l(_vm.inMemoriam, function(remembered) {
                  return _c(
                    "article",
                    {
                      staticClass: "remembered",
                      attrs: { "data-testid": "about_in_memoriam_grid_item" }
                    },
                    [
                      _c("img", {
                        staticClass: "remembered-avatar",
                        attrs: {
                          src:
                            "/site_media/version-0/images/about/" +
                            remembered.avatar +
                            ".jpg",
                          alt: remembered.name,
                          "data-testid": "about_in_memoriam_avatar"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(remembered.name))])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "light-hr" }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "lead",
                  attrs: { "data-testid": "about_in_memoriam_text" }
                },
                [
                  _vm._v(
                    "\n        We remember our friends and colleagues Carrie and Kristian who passed tragically in a\n        diving boat accident on Sept 2, 2019. We’re grateful for the time we spent together and\n        the memories we’ll forever cherish.\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _vm._m(6)
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("LandingFooter")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "about-hero", attrs: { "data-testid": "about_hero" } },
      [
        _c("header", [_c("h1", [_vm._v("About Us")])]),
        _vm._v(" "),
        _c("article", [
          _c(
            "div",
            {
              staticClass: "section-description",
              attrs: { "data-testid": "about_hero_description" }
            },
            [
              _c("p", [
                _vm._v(
                  "\n            Brilliant's mission is to inspire and develop people to achieve their goals in STEM —\n            one person, one question, and one small commitment to learning at a time.\n          "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "no-margin-bottom" }, [
                _vm._v(
                  "\n            We enable great teachers to illuminate the soul of math, science, and engineering\n            through bite-sized, interactive learning experiences. Our courses explore the laws\n            that shape our world, elevating math and science from something to be feared to a\n            delightful experience of guided discovery.\n          "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "section-image" }, [
            _c("img", {
              staticClass: "no-margin-bottom",
              attrs: {
                src: "/site_media/version-0/images/about/pensative-bot.svg",
                alt: "Bot doing math",
                "data-testid": "about_hero_section_img"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "no-margin-top" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [_c("h2", [_vm._v("Team")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [_c("h2", [_vm._v("Careers")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-image" }, [
      _c("img", {
        attrs: {
          src: "/site_media/version-0/images/about/chilling-friends.svg",
          alt:
            "Vampire drinks soda while granny plays videogame and galileo reads on the couch."
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [_c("h2", [_vm._v("Press")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [_c("h2", [_vm._v("In Memoriam")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "article",
      {
        staticClass: "poem",
        attrs: { "data-testid": "about_in_memoriam_poem" }
      },
      [
        _c("p", [
          _vm._v("\n          They are alive and well somewhere;"),
          _c("br"),
          _vm._v(
            "\n          The smallest sprouts show there is really no death,"
          ),
          _c("br"),
          _vm._v(
            "\n          And if ever there was it led forward life, and does not wait at the end to arrest it,"
          ),
          _c("br"),
          _vm._v("And\n          ceas'd the moment life appear'd.\n        ")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n          All goes onward and outward, nothing collapses,"),
          _c("br"),
          _vm._v(
            "\n          And to die is different from what any one supposed, and luckier.\n        "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("— Walt Whitman")])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }